import { ofType, Epic } from 'redux-observable';
import { of } from 'rxjs';
import { catchError, map, mergeMap } from 'rxjs/operators';
import { AjaxResponse, AjaxError } from 'rxjs/ajax';
import { get, post } from '__utils/ajax-wrapper';
import { FluxStandardAction } from '__utils/type';
import { ENDPOINTS } from 'constants/endpoints';
import * as Actions from 'constants/actions';
import * as UserActions from './user.actions';
import resolveURLParams from '__utils/url-params-resolver';
import { getAgentCode } from '__utils/storage';

export const getAgentDetailsEpic: Epic<FluxStandardAction, FluxStandardAction> = action$ => {
    return action$.pipe(
        ofType(Actions.FETCH_GET_AGENT_DETAILS),
        mergeMap((action) => {
            return get(resolveURLParams(ENDPOINTS.GET_AGENT_DETAILS, {agentCode: action.payload.data}, null), {}, true).pipe(
                map((response: AjaxResponse | AjaxError): FluxStandardAction => {
                    if (response.status === 200 && response.response.operationMessage === 'success') {
                        return UserActions.fetchAgentDetailsSuccess(response.response.responseData);
                    } else {
                        return UserActions.fetchAgentDetailsError(response.response);
                    }
                }),
                catchError(error => of(UserActions.fetchAgentDetailsError(error)))
            );
        })
    );
};
export const getAgentCertificatesEpic: Epic<FluxStandardAction, FluxStandardAction> = action$ => {
    return action$.pipe(
        ofType(Actions.FETCH_GET_AGENT_CERTIFICATES),
        mergeMap((action) => {
            return get(resolveURLParams(ENDPOINTS.GET_AGENT_CERTIFICATES, null, {agentCode: action.payload.data}), {}, true).pipe(      
                map((response: AjaxResponse | AjaxError): FluxStandardAction => {
                    if (response.status === 200 && response.response.operationMessage === 'success') {
                        return UserActions.fetchAgentCertificatesSuccess(response.response.responseData);
                    } else {
                        return UserActions.fetchAgentCertificatesSuccess(null);
                    }
                }),
                catchError(error => of(UserActions.fetchAgentCertificatesSuccess(null)))
            );
        })
    );
};

export const getUserProfileInfoEpic: Epic<FluxStandardAction, FluxStandardAction> = action$ => {
    return action$.pipe(
        ofType(Actions.FETCH_GET_USER_PROFILE_INFO),
        mergeMap((action) => {
            return get(resolveURLParams(ENDPOINTS.GET_USER_PROFILE_INFO, {}, {}), {}, true).pipe(
                map((response: AjaxResponse | AjaxError): FluxStandardAction => {
                    if (response.status === 200) {
                        return UserActions.fetchUserProfileInfoSuccess(response.response);
                    }
                    else {
                        return UserActions.fetchUserProfileInfoError(response.response);
                    }
                }),
                catchError(error => of(UserActions.fetchUserProfileInfoError(error)))
            );
        })
    );
}
export const getAgentProfilePicEpic: Epic<FluxStandardAction, FluxStandardAction> = action$ => {
    return action$.pipe(
        ofType(Actions.FETCH_GET_AGENT_PROFILE_PIC),
        mergeMap((action) => {
            return get(resolveURLParams(ENDPOINTS.GET_AGENT_PROFILE_PICTURE, {agentCode:action.payload.data}, {}), {}, true).pipe(
                map((response: AjaxResponse | AjaxError): FluxStandardAction => {
                    if (response.status === 200 && response?.response?.data) {
                        return UserActions.fetchAgentProfilePicSuccess(response?.response?.data);
                    }
                    else {
                        return UserActions.fetchAgentProfilePicSuccess(undefined);
                    }
                }),
                catchError(error => of(UserActions.fetchAgentProfilePicSuccess(error)))
            );
        })
    );
}

export const getDiwaliPdfEpic: Epic<FluxStandardAction, FluxStandardAction> = action$ => {
    return action$.pipe(
        ofType(Actions.FETCH_GET_DIWALI_PDF),
        mergeMap((action) => {            
            return get(resolveURLParams(ENDPOINTS.GET_DIWALI_PDF, {templateType:'PDF',brandingType:'DIWALI',lang: action.payload.data}, {}), {}, true).pipe(
                map((response: AjaxResponse | AjaxError): FluxStandardAction => {                    
                    if (response?.response?.operationMessage === 'success') {
                        return UserActions.fetchDiwaliGiftPdfSuccess(response?.response?.responseData);
                    }
                    else {
                        return UserActions.fetchDiwaliGiftPdfSuccess(undefined);
                    }
                }),
                catchError(error => of(UserActions.fetchDiwaliGiftPdfSuccess(error)))
            );
        })
    );
}

export const getCustomerCountEpic: Epic<FluxStandardAction, FluxStandardAction> = action$ => {
    return action$.pipe(
        ofType(Actions.FETCH_GET_CUSTOMER_COUNT),
        mergeMap((action) => {
            return get(resolveURLParams(ENDPOINTS.MY_CUSTOMERS, {agentCode:action.payload.data}, {}), {}, false).pipe(
                map((response: AjaxResponse | AjaxError): FluxStandardAction => {
                    if (response?.response) {
                        return UserActions.fetchCustomerCountSuceess(response?.response);
                    }
                    else {
                        return UserActions.fetchCustomerCountSuceess(undefined);
                    }
                }),
                catchError(error => of(UserActions.fetchCustomerCountSuceess(undefined)))
            );
        })
    );
}
export const getFetchAgentVerificationEpic: Epic<FluxStandardAction, FluxStandardAction> = action$ => {
    return action$.pipe(
        ofType(Actions.FETCH_GET_AGENT_VERIFICATION),
        mergeMap((action) => {
            return get(resolveURLParams(ENDPOINTS.GET_ALLOWED_MINT_AGENT, {agentCode:action.payload.data}, {}), {}, false).pipe(
                map((response: AjaxResponse | AjaxError): FluxStandardAction => {
                    if (!(response.response && response.response?.value) && response.response?.key == false) {
                        return UserActions.fetchAgentVerificationSuccess(true);
                    }
                    else {
                        return UserActions.fetchAgentVerificationSuccess(false);
                    }
                }),
                catchError(error => of(UserActions.fetchAgentVerificationSuccess(false)))
            );
        })
    );
}

//todo: see userPaymentDetailView
export const getCustomerOrderDetailsEpic: Epic<FluxStandardAction, FluxStandardAction> = action$ => {
    return action$.pipe(
        ofType(Actions.FETCH_GET_CUSTOMER_ORDER_DETAILS),
        mergeMap((action) => {
            return get(ENDPOINTS.GET_ORDER_DETAILS, {}, true).pipe(
                map((response: AjaxResponse | AjaxError): FluxStandardAction => {
                    if (response?.response?.data && response.response.data[ 0 ]?.paymentUrl) {
                        return UserActions.fetchCustomerOrderDetailsSuccess(response.response.data[0]);
                    }
                    else {
                        return UserActions.fetchCustomerOrderDetailsSuccess('');
                    }
                }),
                catchError(error => of(UserActions.fetchCustomerOrderDetailsSuccess('')))
            );
        })
    );
}
export const getCalculatorLeadsCountEpic: Epic<FluxStandardAction, FluxStandardAction> = action$ => {
    return action$.pipe(
        ofType(Actions.FETCH_GET_CALCULATOR_LEADS_COUNT),
        mergeMap((action) => {
            return get(`${ENDPOINTS.GET_CALCULATOR_LEADS_COUNT}?agentCode=${getAgentCode()}`, {}, true).pipe(
                map((response: AjaxResponse | AjaxError): FluxStandardAction => {
                    if (response?.response?.data !== null) {
                        return UserActions.fetchGetCalculatorLeadsCountSuccess(response.response.data);
                    }
                    else {
                        return UserActions.fetchGetCalculatorLeadsCountSuccess(null);
                    }
                }),
                catchError(error => of(UserActions.fetchGetCalculatorLeadsCountSuccess(null)))
            );
        })
    );
}

export const postMergeCartsEpic: Epic<FluxStandardAction, FluxStandardAction> = action$ => {
    return action$.pipe(
        ofType(Actions.FETCH_POST_MERGE_CARTS),
        mergeMap((action) => {
            return post(resolveURLParams(ENDPOINTS.POST_MERGE_CARTS, action.payload, null), action.payload, {}, true).pipe(
                map((response: AjaxResponse | AjaxError): FluxStandardAction => {
                    if (response.status === 200) { 
                        return UserActions.fetchPostMergeCartsSuccess(response.response);
                    } else {
                        return UserActions.fetchPostMergeCartsSuccess(response.response);
                    }
                }),
                catchError(error => of(UserActions.fetchPostMergeCartsSuccess(error)))
            );
        })
    );
};